import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonType, DeviceTypes } from '@iotv/iotv-v3-types';
import { deviceEnabledTypes } from '@iotv/payload-definition';
import { MenuItem, TextField, Toolbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
export const TypeByDeviceType = (props) => {
    const { updateParams: setParamsInParent, lastQuery, lastQueryParamsRef, type, keyPress, index, attKey, children, selected } = props;
    const getDeviceKeys = () => {
        const allowedKeys = Object.values(deviceEnabledTypes)
            .map((val) => {
            const mappedTypes = Object.values(val.deviceTypes)
                .map((devType) => {
                return Object.values(devType);
            })
                .flat();
            return mappedTypes;
        })
            .flat();
        const flatKeys = [...new Set(allowedKeys)];
        const types = flatKeys.map((key) => {
            return DeviceTypes[key];
        });
        return types.sort((a, b) => {
            return a.localeCompare(b, undefined, {
                numeric: true,
                sensitivity: 'base',
            });
        });
    };
    const [params, setParams] = useState(lastQuery);
    const [options, _] = useState(getDeviceKeys());
    const updateParamsWithSelected = (value) => {
        const inferred = DeviceTypes[value];
        if (inferred) {
            const selectedParam = { type, attKey, value: inferred };
            lastQueryParamsRef.current = selectedParam;
            setParams(selectedParam);
        }
    };
    useEffect(() => {
        if (options.length > 0) {
            updateParamsWithSelected(options[0]);
        }
    }, [options]);
    useEffect(() => {
        if (params && selected) {
            setParamsInParent([{ key: attKey, value: params.value, predicate: ComparisonType.EQUALS }], index);
        }
        else {
            setParamsInParent(undefined, index);
        }
    }, [params, selected]);
    const handleParamChange = (e) => {
        const value = e.target.value;
        updateParamsWithSelected(value);
    };
    const displayDeviceTypes = (val) => {
        if (!val)
            return '';
        const type = DeviceTypes[parseInt(val)];
        return `${type} (${val})`;
    };
    return (_jsxs(Toolbar, { variant: "dense", children: [children, _jsx(TextField, { select: true, value: params?.value || '', size: "small", onChange: handleParamChange, onKeyDown: keyPress, slotProps: { select: { renderValue: () => _jsx(_Fragment, { children: displayDeviceTypes(params?.value) }) } }, children: options.map((types) => (_jsx(MenuItem, { value: types, children: _jsx("b", { children: types }) }, types))) })] }));
};
